import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { fmtPay } from './rateUtils';

const RateRow = ({ item }) => {
  const [open, setOpen] = useState(false);
  const hasDef = Boolean(item.definition);

  return (
    <div className="border-b border-slate-800/80 last:border-b-0" data-testid={`rate-row-${item.code}`}>
      <button
        type="button"
        onClick={() => hasDef && setOpen((o) => !o)}
        className={`w-full text-left px-4 sm:px-5 py-3.5 grid grid-cols-[auto_1fr_auto] sm:grid-cols-[110px_1fr_110px_28px] gap-x-3 sm:gap-x-4 gap-y-1 items-center transition-colors ${hasDef ? 'hover:bg-violet-500/5 cursor-pointer' : 'cursor-default'}`}
        aria-expanded={open}
        data-testid={`rate-row-toggle-${item.code}`}
      >
        <span className="font-mono text-xs sm:text-sm font-semibold text-violet-300 bg-violet-500/10 border border-violet-500/20 rounded-md px-2 py-1 justify-self-start">
          {item.code}
        </span>
        <span className="col-span-3 row-start-2 sm:col-span-1 sm:row-start-auto text-sm text-slate-200 leading-snug">
          {item.description}
        </span>
        <span className="col-start-3 row-start-1 sm:col-start-auto sm:row-start-auto text-right font-bold text-cyan-300 tabular-nums text-sm sm:text-base" data-testid={`rate-pay-${item.code}`}>
          {fmtPay(item.pay)}
        </span>
        <span className="hidden sm:flex justify-end text-slate-500">
          {hasDef && <ChevronDown size={18} className={`transition-transform duration-200 ${open ? 'rotate-180 text-violet-300' : ''}`} />}
        </span>
      </button>
      {hasDef && open && (
        <div className="px-4 sm:px-5 pb-4 sm:pl-[142px]" data-testid={`rate-definition-${item.code}`}>
          <p className="text-[13px] leading-relaxed text-slate-400 bg-[#0A0A0F] border border-slate-800 rounded-lg p-3 sm:p-4 whitespace-pre-line">
            <span className="text-slate-300 font-semibold">Definition · {item.unit || 'EACH'} — </span>
            {item.definition}
          </p>
        </div>
      )}
      {hasDef && !open && (
        <p className="sm:hidden px-4 -mt-2 pb-3 text-[11px] text-slate-500">Tap to view definition</p>
      )}
    </div>
  );
};

export const RateSectionView = ({ section }) => (
  <section className="bg-[#12121A] border border-slate-800 rounded-2xl overflow-hidden" data-testid={`rate-section-${section.id}`}>
    <div className="flex items-center justify-between px-4 sm:px-5 py-4 border-b border-slate-800 bg-gradient-to-r from-violet-600/15 to-transparent">
      <h3 className="text-base sm:text-lg font-bold text-white" style={{ fontFamily: 'Syne, sans-serif' }}>
        {section.name} <span className="text-slate-500 font-medium text-sm">· Pay Rates</span>
      </h3>
      <span className="text-xs text-slate-500">{section.items.length} codes</span>
    </div>
    <div className="hidden sm:grid grid-cols-[110px_1fr_110px_28px] gap-x-4 px-5 py-2 text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-800">
      <span>Article</span><span>Description</span><span className="text-right">Pay</span><span />
    </div>
    {section.items.map((item) => <RateRow key={item.id} item={item} />)}
  </section>
);
